// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrow_arrow___32nu","passive":"Arrow_passive__Nbo_X","arrow-in":"Arrow_arrow-in__hGPl5"};